import * as React from 'react';
import { Label } from '../../../../ui/label/label';
import { PikDropdown } from '../../../../ui/pik_dropdown/pik_dropdown';
import { connect } from 'react-redux';
import { IApplicationState, TTypedThunkDispatch } from '../../../../types/redux';
import { dateChange } from '../../../../actions/filter';

interface IDateProps {
  date: number | undefined;
  dateVariations: number[];
  setDate(value: number | undefined): void;
}

function mapDate(date: number) {
  return {
    label: `До конца ${date}`,
    value: date,
  };
}

class Date extends React.PureComponent<IDateProps, object> {
  public render() {
    return (
      <Label text="Срок сдачи:">
        <PikDropdown
          placeholder="Неважно"
          value={this.props.date as number}
          onValueChange={this.setDate}
          values={this.props.dateVariations.map(mapDate)}
        />
      </Label>
    );
  }

  private setDate = (value: number) => {
    this.props.setDate(value === this.props.date ? undefined : value);
  };
}

export const DateField = connect(
  (state: IApplicationState) => ({
    date: state.filter.query.date,
    dateVariations: state.filter.dateVariations,
  }),
  (dispatch: TTypedThunkDispatch) => {
    return {
      setDate: (date: number | undefined) => {
        dispatch(dateChange(date));
      },
    };
  },
)(Date);
